// API configurations
const API_CONFIG = {
  // Use environment variable or fallback to development/production logic
  BASE_URL: process.env.REACT_APP_API_URL || 
    (process.env.NODE_ENV === 'development' 
      ? 'http://localhost:5000/api' 
      : 'https://app-backends.vercel.app/api'),
  TIMEOUT: 30000, // 30 seconds
  ENDPOINTS: {
    LOGIN: '/auth/login',
    CATEGORIES: '/categories',
    SUBCATEGORIES: '/subcategories',
    POSTS: '/posts',
    HEALTH: '/health',
    PING: '/ping'
  }
};

export default API_CONFIG; 